namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsCustomerSurveyDialog extends Serenity.EntityDialog<PsCustomerSurveyRow, any> {
        protected getFormKey() { return PsCustomerSurveyForm.formKey; }
        protected getIdProperty() { return PsCustomerSurveyRow.idProperty; }
        protected getLocalTextPrefix() { return PsCustomerSurveyRow.localTextPrefix; }
        protected getNameProperty() { return PsCustomerSurveyRow.nameProperty; }
        protected getService() { return PsCustomerSurveyService.baseUrl; }
        protected getDeletePermission() { return PsCustomerSurveyRow.deletePermission; }
        protected getInsertPermission() { return PsCustomerSurveyRow.insertPermission; }
        protected getUpdatePermission() { return PsCustomerSurveyRow.updatePermission; }

        protected form = new PsCustomerSurveyForm(this.idPrefix);

        private  user: string ;

        constructor() {
            super();

        this.form.TimeFg.changeSelect2(e => {
            var setpromotimefg:string = this.form.TimeFg.value;
            // var setpromotimefgn = this.setPromoTimeFgn;
            if (setpromotimefg == "1") {
                Serenity.EditorUtils.setReadOnly(this.form.StartTime, false);
                Serenity.EditorUtils.setReadOnly(this.form.EndTime, false);
               
            } 
            else{

                Serenity.EditorUtils.setReadOnly(this.form.StartTime, true);
                Serenity.EditorUtils.setReadOnly(this.form.EndTime, true);
                this.form.StartTime.value = null
                this.form.EndTime.value = null
            }
        });

        this.form.PosFg.changeSelect2(e => {
            var setpromotimefg:string = this.form.PosFg.value;
            // var setpromotimefgn = this.setPromoTimeFgn;
            if (setpromotimefg == "1") {
                Serenity.EditorUtils.setReadOnly(this.form.PosId, false);
                // Serenity.EditorUtils.setReadOnly(this.form.EndTime, false);
               
            } 
            else{

                Serenity.EditorUtils.setReadOnly(this.form.PosId, true);
                // Serenity.EditorUtils.setReadOnly(this.form.EndTime, true);
                this.form.PosId.value = null
                // this.form.EndTime.value = null
            }
        });

    }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            
            if (this.isEditMode) {
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active",
                    hint: "Active [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        Q.confirm(
                           '  ยืนยันการเปิดแสดง',
                            () => {
                                this.form.Status.value = "1";
                                this.form.ActiveBy.value = this.user;
                            this.form.Activedate.value = (new Date(Date.now())).toDateString();
                                this.form.Status.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "InActive",
                hint: "ยกเลิก Active",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-times-circle text-red",
                
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการเปิดแสดงนี้ "
                        ,
                        () => {
                            this.form.Status.value = "0";
                            this.form.ActiveBy.value = this.user;
                            this.form.Activedate.value = (new Date(Date.now())).toDateString();
                            this.form.Status.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if(this.isNew()){
                this.form.StartDate.value = (new Date(Date.now())).toDateString();
            }
            
            this.form.DtList.myPassValue = this.entity.SurveyCode

            
            var userId = null;
            var userItems = Administration.UserRow.getLookup().items;
            if (userItems && userItems.length > 0) {
                userId = Q.first(userItems, x => x.Username == Authorization.userDefinition.Username);
            }
            
            if (userId) {
                this.user = userId.Username;
            } else {
                this.user = Authorization.userDefinition.Username || '';
            }
            // var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);
          

           
                if (this.entity.Status == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    // this.toolbar.findButton('button-save-cancle').hide();
                    // this.toolbar.findButton('button-save-reject').hide();
                } else {
                    // this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();

                }
            
        }

    }
}